import { render } from "./index.vue?vue&type=template&id=2a56379d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2a56379d&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2a56379d&lang=less"
script.render = render
script.__scopeId = "data-v-2a56379d"

export default script